import { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  Divider,
  Stack,
} from "@mui/material";
import { Close, Add } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  XIcon,
  WhatsappIcon,
} from "react-share";
import base from "../../api/apis";
import { useDispatch } from "react-redux";

const ShareProperty = ({ share = false, setShare, url }) => {
  const dispatch = useDispatch();

  const [emailIndex, setEmailIndex] = useState([0]);
  const [currEmail, setCurrEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [email3, setEmail3] = useState("");
  const [email4, setEmail4] = useState("");
  const [note, setNote] = useState("");
  const [shareLoad, setShareLoad] = useState(false);

  const addEmails = () => {
    setEmailIndex((prev) => {
      if (prev.length > 4) {
        return prev;
      }
      const newVal = prev + 1;
      return [...prev, newVal];
    });
  };

  const removeEmail = (index) => {
    const newIndex = emailIndex.filter((el) => emailIndex[index] !== el);
    if (index === 1) {
      setEmail1("");
    }
    if (index === 2) {
      setEmail2("");
    }
    if (index === 3) {
      setEmail3("");
    }
    if (index === 4) {
      setEmail4("");
    }
    setEmailIndex(newIndex);
  };

  const closeShare = () => {
    setShare(false);
    setNote("");
    setCurrEmail("");
    setEmail1("");
    setEmail2("");
    setEmail3("");
    setEmail4("");
    setEmailIndex([1]);
  };

  const updateEmails = (e, index) => {
    if (index === 0) {
      setCurrEmail(e.target.value);
    }
    if (index === 1) {
      setEmail1(e.target.value);
    }
    if (index === 2) {
      setEmail2(e.target.value);
    }
    if (index === 3) {
      setEmail3(e.target.value);
    }
    if (index === 4) {
      setEmail4(e.target.value);
    }
  };

  const shareListing = async () => {
    const data = {
      emails: [currEmail, email1, email2, email3, email4],
      property_url: window.location.href,
      note,
    };
    if (note === "" || currEmail === "") {
      dispatch({
        type: "ERROR",
        payload: "Invalid, provide an email and notes",
      });
      return;
    }
    setShareLoad(true);
    try {
      await base.post(`/leads/share-property/`, data);
      setShareLoad(false);
      setNote("");
      setCurrEmail("");
      setEmail1("");
      setEmail2("");
      setEmail3("");
      setEmail4("");
      setShare(false);
      dispatch({ type: "SUCCESS", payload: "Email sent successfully" });
    } catch (error) {
      setShareLoad(false);
      dispatch({ type: "ERROR", payload: "Sorry, could not send email" });
    }
  };

  return (
    <Dialog open={share} maxWidth="xs" fullWidth onClose={closeShare}>
      <DialogContent sx={{ position: "relative", padding: "2rem" }}>
        <IconButton
          onClick={closeShare}
          sx={{ position: "absolute", top: "5%", right: "5%" }}
        >
          <Close fontSize="small" />
        </IconButton>
        <Typography mb={3} variant="h6">
          Share Listing
        </Typography>
        {emailIndex.map((el, index) => {
          return (
            <TextField
              key={index}
              size="small"
              value={
                index === 0
                  ? currEmail
                  : index === 1
                  ? email1
                  : index === 2
                  ? email2
                  : index === 3
                  ? email3
                  : index === 4
                  ? email4
                  : ""
              }
              onChange={(e) => updateEmails(e, index)}
              fullWidth
              placeholder="Email address"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {index === 0 ? (
                      <IconButton onClick={addEmails}>
                        <Add fontSize="small" />
                      </IconButton>
                    ) : (
                      <IconButton onClick={() => removeEmail(index)}>
                        <Close fontSize="small" />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
              sx={{ mb: "1rem" }}
            />
          );
        })}
        <TextField
          sx={{ mb: "1rem" }}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          multiline
          rows={5}
          placeholder="Enter your note"
          fullWidth
        />
        <LoadingButton
          loading={shareLoad}
          variant="contained"
          size="large"
          onClick={shareListing}
          disableElevation
          sx={{ textTransform: "none" }}
          fullWidth
          color="secondary"
        >
          Send
        </LoadingButton>

        <Divider sx={{ my: "1rem" }} />

        <Stack
          direction="row"
          gap={1}
          justifyContent="center"
          alignItems="center"
        >
          <FacebookShareButton url={url}>
            <FacebookIcon size={40} rounded borderRadius={8} />
          </FacebookShareButton>
          <LinkedinShareButton url={url}>
            <LinkedinIcon size={40} rounded borderRadius={8} />{" "}
          </LinkedinShareButton>
          <TwitterShareButton url={url}>
            <XIcon size={40} rounded borderRadius={8} />
          </TwitterShareButton>
          <WhatsappShareButton url={url}>
            <WhatsappIcon size={40} rounded borderRadius={8} />
          </WhatsappShareButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ShareProperty;
